import TransparentButton from './TransparentButton.component';

export default TransparentButton;
